import { ReactNode } from "react";

import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import LoadingIndicator from "ds/components/LoadingIndicator";

import styles from "./styles.module.css";

type CommandPaletteSubListProps = {
  breadcrumb: string[];
  loading?: boolean;
  children: ReactNode;
};

const CommandPaletteSubList = ({ breadcrumb, loading, children }: CommandPaletteSubListProps) => {
  return (
    <Box direction="column" grow="1" fullWidth>
      <Box
        className={styles.breadcrumb}
        padding="x-large x-large medium"
        gap="medium"
        align="center"
      >
        <Typography variant="p-t8" tag="span" color="secondary" transform="uppercase">
          {breadcrumb.join(" > ")}
        </Typography>

        <LoadingIndicator loading={loading} />
      </Box>

      <Box direction="column" padding="0 x-large x-large" gap="small" grow="1">
        {children}
      </Box>
    </Box>
  );
};

export default CommandPaletteSubList;
